import * as React from 'react';
import { Layout, Row, Col, Card, Button, Divider, message, Popover } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import {
	invoicesRestCrudThunksForBuyer,
	updateInvoiceGLCodeForBuyer,
	updateInvoicePONumberForBuyer,
} from '../../thunks/invoices_thunks';
import {
	dateFormatter,
	getTimeDurationFromSeconds,
	optionalFilter,
} from '../../utils/DataFormatterUtils';
import {
	getCurrency,
	isInvoiceTotalGreaterThanNTE,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { EmptyState } from '../empty_state/EmptyState';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import EditGLCodeForm from '../edit_gl_code_form/EditGLCodeForm';
import EditPONumberForm from '../edit_po_number_form/EditPONumberForm';
import InvoiceActions from '../common/InvoiceActions';
import InvoicesAdditionalDetails from '../invoices_components/InvoicesAdditionalDetails';
import { UserName } from '../name_component/user/UserNameComponent';
import { Link } from 'react-router-dom';
import {
	appendWorkOrderNotesForBuyer,
	workOrdersRestCrudThunksForBuyer,
} from '../../thunks/work_orders_thunks';
import { BUYER_ADMIN, BUYER_USER, SUPER_ADMIN } from '../roles/roles';
import InvoiceUploader from '../invoice_uploader/InvoiceUploader';
import { INVOICE_STATUSES } from '../../constants/InvoiceStatuses';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const { Content } = Layout;

require('./WorkOrdersDetailInvoicesPage.less');
const dateFormat = 'MMM D, YYYY';

class WorkOrderInvoicesDetailPage extends React.Component<any, any> {
	formRefs: any;

	constructor(props) {
		super(props);

		this.formRefs = {
			editGLCodeForm: null,
			editPONumberForm: null,
		};

		this.state = {
			editGLCodeFormVisible: false,
			editPONumberFormVisible: false,
			selectedInvoice: {},
			invoiceExists: false,
		};
	}

	refreshInvoice = () => {
		const { getWorkOrder, getInvoices, getCount, workOrder, match } = this.props;
		const workOrderId = workOrder.id || nullSafeGet('params.id', match);
		getInvoices({ workOrderId }, 'workOrderAssociatedInvoices');
		getCount(workOrderId, 'draft').then((d) => this.setState({ invoiceExists: d > 0 }));
		getWorkOrder(workOrderId);
	};

	componentDidMount() {
		const { getInvoices, getCount, workOrder, match } = this.props;
		const workOrderId = workOrder.id || nullSafeGet('params.id', match);
		getInvoices({ workOrderId }, 'workOrderAssociatedInvoices');
		getCount(workOrderId, 'draft').then((d) => this.setState({ invoiceExists: d > 0 }));
	}

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	showEditGLCode = (invoice) => {
		this.setState({
			editGLCodeFormVisible: true,
			selectedInvoice: invoice,
		});
	};

	handleEditGLCodeSubmit = () => {
		const { updateGLCode } = this.props;
		const form = this.formRefs['editGLCodeForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const glCode = {
				...values,
			};

			updateGLCode(glCode).then(() => {
				this.setState({ editGLCodeFormVisible: false, selectedInvoice: {} });
				form.resetFields();
			});
		});
	};

	handleEditGLCodeCancel = (e) => {
		this.setState({
			editGLCodeFormVisible: false,
		});
	};

	showEditPONumber = (invoice) => {
		this.setState({
			editPONumberFormVisible: true,
			selectedInvoice: invoice,
		});
	};

	handleEditPONumberSubmit = () => {
		const { updatePONumber } = this.props;
		const form = this.formRefs['editPONumberForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const poNumber = {
				...values,
			};

			updatePONumber(poNumber).then(() => {
				this.setState({ editPONumberFormVisible: false, selectedInvoice: {} });
				form.resetFields();
			});
		});
	};

	handleEditPONumberCancel = (e) => {
		this.setState({
			editPONumberFormVisible: false,
		});
	};

	handleInvoicePDFUploadChange = (invoice) => (invoiceFileUrl) => {
		const { updateInvoice } = this.props;

		const newInvoice = {
			...invoice,
			invoicePDFLink: invoiceFileUrl,
			isDeleted: false,
		};
		updateInvoice(newInvoice).then(() => {
			message.success(`Invoice published.`);
			this.refreshInvoice();
		});
	};

	render() {
		const {
			invoices,
			invoicesFetching,
			match,
			workOrder,
			currentUser,
			history,
			appendWorkOrderNotes,
		} = this.props;
		const workOrderId = workOrder.id;

		const isAdmin =
			currentUser.roles.includes(BUYER_ADMIN) || currentUser.roles.includes(SUPER_ADMIN);
		const isManager = currentUser.roles.includes(BUYER_USER);
		const hasSupplier = !!nullSafeGet('supplierFacilityId', workOrder);

		const associatedInvoices = getRecordsForTargetCollection(
			invoices,
			'workOrderAssociatedInvoices'
		);

		return invoicesFetching ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="invoicesDetailDetailsPage">
				<LogOnMountWithStandardEventProperties eventType="visited buyer work order detail invoices page" />
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				{associatedInvoices.length > 0 ? (
					<div>
						{associatedInvoices.map((invoice) => {
							if (invoice.isDeleted) {
								return (
									<Row gutter={12}>
										<Col span={24}>
											<Card>
												<div>
													<h5 style={{ marginBottom: '4px' }}>Upload an invoice file</h5>
													<div>
														<p
															style={{
																fontSize: 16,
																marginBottom: '0.5em',
															}}
														>
															Add an invoice file (PDF) to finish creating the invoice.
														</p>
														<InvoiceUploader
															roleType="buyer"
															invoiceId={invoice.id}
															buttonType="primary"
															defaultFileList={[]}
															multiple={false}
															handleUploadSuccess={this.handleInvoicePDFUploadChange(invoice)}
														/>
													</div>
												</div>
											</Card>
										</Col>
									</Row>
								);
							}
							const nte = nullSafeGet('workOrder.nte', invoice);
							const totalIsGreaterThanNTE = isInvoiceTotalGreaterThanNTE(invoice, workOrder);

							const isBuyerInvoice = invoice.isBuyerUploaded || false;
							const hasPDF = invoice.invoicePDFLink && invoice.invoicePDFLink.length > 0;
							const currency = getCurrency({
								workOrder: nullSafeGet('workOrder', invoice),
							});
							const pdfElement = hasPDF ? (
								<p className={'mb-1'}>
									<a href={invoice.invoicePDFLink} target="_blank" rel="noreferrer">
										Invoice PDF
									</a>
								</p>
							) : null;
							const uploadInvoice = isAdmin ? (
								isBuyerInvoice ? (
									[INVOICE_STATUSES.pending, INVOICE_STATUSES.disputed].some(
										(status) => status === invoice.status
									) ? (
										<InvoiceUploader
											roleType="buyer"
											invoiceId={invoice.id}
											defaultFileList={[]}
											multiple={false}
											handleUploadSuccess={this.handleInvoicePDFUploadChange(invoice)}
										/>
									) : null
								) : [INVOICE_STATUSES.disputed].some((status) => status === invoice.status) ? (
									<InvoiceUploader
										roleType="buyer"
										invoiceId={invoice.id}
										defaultFileList={[]}
										multiple={false}
										handleUploadSuccess={this.handleInvoicePDFUploadChange(invoice)}
									/>
								) : [INVOICE_STATUSES.pending].some((status) => status === invoice.status) ? (
									<Popover
										content={'Invoice must be disputed status to allow upload of a pdf.'}
										placement={'left'}
									>
										<div>
											<InvoiceUploader
												disabled={true}
												roleType="buyer"
												invoiceId={invoice.id}
												defaultFileList={[]}
												multiple={false}
												handleUploadSuccess={this.handleInvoicePDFUploadChange}
											/>
										</div>
									</Popover>
								) : null
							) : null;

							return (
								<Row style={{ margin: '16px 8px' }} gutter={12} key={invoice.id}>
									<EditGLCodeForm
										formData={invoice}
										wrappedComponentRef={this.saveFormRef('editGLCodeForm')}
										visible={this.state.editGLCodeFormVisible}
										confirming={invoices.updating}
										onCancel={this.handleEditGLCodeCancel}
										onSubmit={this.handleEditGLCodeSubmit}
									/>
									<EditPONumberForm
										formData={invoice}
										wrappedComponentRef={this.saveFormRef('editPONumberForm')}
										visible={this.state.editPONumberFormVisible}
										confirming={invoices.updating}
										onCancel={this.handleEditPONumberCancel}
										onSubmit={this.handleEditPONumberSubmit}
									/>
									<Col span={24}>
										<Card>
											<div className="flex flex-row items-center justify-end">
												{isAdmin || isManager ? (
													<Row className={'flex'}>
														<Button
															style={{ marginLeft: 16 }}
															onClick={() => {
																history.push(`/buyer/invoices/detail/${invoice.id}`);
															}}
														>
															View Invoice Page
														</Button>
														{isBuyerInvoice ? (
															<div className="ml-2">
																<Button
																	onClick={() => {
																		history.push(
																			`/buyer/workOrders/detail/${workOrderId}/invoices/${invoice.id}/edit?btwo=true`
																		);
																	}}
																>
																	Edit
																</Button>
															</div>
														) : null}
													</Row>
												) : null}
											</div>
											{totalIsGreaterThanNTE ? (
												<div className="rowSpacing" style={{ marginTop: 10 }}>
													<Card
														style={{ border: '1px solid #7651f1' }}
														bodyStyle={{
															padding: '16px 24px',
															background: '#f1ebff',
														}}
													>
														<div>
															<h5 style={{ marginBottom: '4px' }}>
																Total is greater than NTE Amount
															</h5>
															<div>
																<p
																	style={{
																		fontSize: 16,
																		marginBottom: '0.5em',
																	}}
																>
																	This invoice exceeds the not-to-exceed amount of{' '}
																	{currency.format(nte)} for this work order. Please increase this
																	work orders NTE or request your service provider change the
																	invoice total.
																</p>
															</div>
														</div>
													</Card>
												</div>
											) : (
												<InvoiceActions
													invoice={invoice}
													refreshInvoice={this.refreshInvoice}
													appendWorkOrderNotes={appendWorkOrderNotes}
												/>
											)}
											<InvoicesAdditionalDetails
												invoice={invoice}
												passthroughItems={[
													{
														key: 'GL Code',
														value: (
															<div>
																{optionalFilter(invoice.glCode)}
																<Button onClick={this.showEditGLCode} size="large" type="link">
																	<i className="icons8-font icons8-edit">Edit</i>
																</Button>
															</div>
														),
													},
													{
														key: 'PO Number',
														value: (
															<div>
																{optionalFilter(invoice.poNumber)}
																<Button onClick={this.showEditPONumber} size="large" type="link">
																	<i className="icons8-font icons8-edit">Edit</i>
																</Button>
															</div>
														),
													},
													pdfElement || uploadInvoice
														? {
																key: 'File',
																value: (
																	<div>
																		{pdfElement}
																		{uploadInvoice}
																	</div>
																),
																className: 'detailRow__item firstRow lastCol',
														  }
														: {},
													invoice.createdByContact
														? {
																key: 'Submitted By',
																value: (
																	<UserName
																		contact={invoice.createdByContact}
																		mode={'inline'}
																		placement={'top'}
																	/>
																),
														  }
														: {},
													{
														key: 'Submitted By Company',
														value: isBuyerInvoice
															? nullSafeGet('buyerCompany.displayName', workOrder)
															: nullSafeGet('supplierFacility.displayName', workOrder),
													},
													{
														key: 'Submitted On',
														value: dateFormatter(invoice.createdAt, dateFormat),
													},
													invoice.approvedByContact
														? {
																key: 'Approved By',
																value: (
																	<UserName
																		contact={invoice.approvedByContact}
																		mode={'inline'}
																		placement={'top'}
																	/>
																),
														  }
														: {},
													invoice.approvedAt
														? {
																key: 'Approved On',
																value: dateFormatter(invoice.approvedAt, dateFormat),
														  }
														: {},
													invoice.markedPaidByContact
														? {
																key: 'Paid By',
																value: (
																	<UserName
																		contact={invoice.markedPaidByContact}
																		mode={'inline'}
																		placement={'top'}
																	/>
																),
														  }
														: {},
													invoice.markedPaidAt
														? {
																key: 'Paid On',
																value: dateFormatter(invoice.markedPaidAt, dateFormat),
														  }
														: {},
												]}
											/>
											<Divider />
											<div className="sectionHeaderWrapper" style={{ marginBottom: 8 }}>
												<span className="sectionHeaderText">Labor</span>
												<span className="sectionHeaderText2">
													{currency.format(invoice.laborTotalBeforeTax)}
												</span>
											</div>
											{nullSafeGetOrElse('laborLineItems', invoice, []).map((lli, idx) => (
												<div
													className="sectionHeaderWrapper2"
													style={{
														marginBottom:
															idx === nullSafeGetOrElse('laborLineItems', invoice, []).length - 1
																? 16
																: 8,
													}}
												>
													<span className="lineItemDetailText">
														{lli.numberOfTech} {lli.roleType} *{' '}
														{getTimeDurationFromSeconds(lli.seconds)} @{' '}
														{currency.format(parseFloat(lli.hourlyRate))} / hour
													</span>
													<span className="lineItemDetailText">
														{currency.format(parseFloat(lli.amount))}
													</span>
												</div>
											))}
											<Divider />

											<div className="sectionHeaderWrapper" style={{ marginBottom: 8 }}>
												<span className="sectionHeaderText">Materials</span>
												<span className="sectionHeaderText2">
													{currency.format(invoice.materialTotalBeforeTax)}
												</span>
											</div>
											{nullSafeGetOrElse('materialLineItems', invoice, []).map((mli, idx) => (
												<div
													className="sectionHeaderWrapper2"
													style={{
														marginBottom:
															idx === nullSafeGetOrElse('laborLineItems', invoice, []).length - 1
																? 16
																: 8,
													}}
												>
													<span className="lineItemDetailText">
														{mli.quantity} {mli.unitType} of {mli.description}
														{mli.partNumber ? ` (${mli.partNumber})` : null} @{' '}
														{currency.format(parseFloat(mli.unitPrice))} / {mli.unitType}
													</span>
													<span className="lineItemDetailText">
														{currency.format(parseFloat(mli.amount))}
													</span>
												</div>
											))}
											<Divider />
											<div className="sectionHeaderWrapper">
												<span className="sectionHeaderText">Travel</span>
												<span className="sectionHeaderText2">
													{currency.format(parseFloat(invoice.travelTotalBeforeTax) || 0)}
												</span>
											</div>
											<Divider />
											<div className="sectionHeaderWrapper">
												<span className="sectionHeaderText">Freight</span>
												<span className="sectionHeaderText2">
													{currency.format(parseFloat(invoice.freightTotalBeforeTax) || 0)}
												</span>
											</div>
											<Divider />
											<div className="sectionHeaderWrapper">
												<span className="sectionHeaderText">Miscellaneous</span>
												<span className="sectionHeaderText2">
													{currency.format(parseFloat(invoice.miscTotalBeforeTax) || 0)}
												</span>
											</div>
											{nullSafeGetOrElse('miscLineItems', invoice, []).map((mli, idx) => (
												<div
													className="sectionHeaderWrapper2"
													style={{
														marginBottom:
															idx === nullSafeGetOrElse('miscLineItems', invoice, []).length - 1
																? 16
																: 8,
													}}
												>
													<span className="lineItemDetailText">{mli.description}</span>
													<span className="lineItemDetailText">
														{currency.format(parseFloat(mli.amount))}
													</span>
												</div>
											))}
											<Divider />
											<div className="sectionHeaderWrapper">
												<span className="sectionHeaderText">Total Before Tax</span>
												<span className="sectionHeaderText2">
													{currency.format(invoice.invoiceTotalBeforeTax)}
												</span>
											</div>
											<Divider />
											<div className="sectionHeaderWrapper">
												<span className="sectionHeaderText">Tax</span>
												<span className="sectionHeaderText2">
													{currency.format(invoice.invoiceTax)}
												</span>
											</div>
											{nullSafeGetOrElse('taxLineItems', invoice, []).map((lli, idx) => (
												<div
													className="sectionHeaderWrapper2"
													style={{
														marginBottom:
															idx === nullSafeGetOrElse('taxLineItems', invoice, []).length - 1
																? 16
																: 8,
													}}
												>
													<span className="lineItemDetailText">{lli.taxType}</span>
													<span className="lineItemDetailText">
														{currency.format(parseFloat(lli.amount))}
													</span>
												</div>
											))}
											<Divider />
											<div className="sectionHeaderWrapper">
												<span className="sectionHeaderText" style={{ fontWeight: 600 }}>
													Total After Tax
												</span>
												<span className="sectionHeaderText2" style={{ fontWeight: 600 }}>
													{currency.format(invoice.invoiceTotalAfterTax)}
												</span>
											</div>
										</Card>
									</Col>
								</Row>
							);
						})}
					</div>
				) : (
					<EmptyState
						graphic={
							<img
								alt="You haven't received an invoice for this work order yet."
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/bank terminal.svg"
							/>
						}
						headline={"You haven't received an invoice for this work order yet."}
						body={
							hasSupplier ? (
								!this.state.invoiceExists ? (
									<AccessPermissionChecker name={PERMISSION_NAMES.CAN_UPLOAD_INVOICES_FOR_SUPPLIER}>
										<div style={{ textAlign: 'center' }}>
											<Link to={`/buyer/workOrders/detail/${workOrderId}/invoices/new`}>
												<Button type="primary">Create Invoice</Button>
											</Link>
										</div>
									</AccessPermissionChecker>
								) : (
									<span>
										Your service provider has drafted an invoice, it just hasn't been published yet.
									</span>
								)
							) : null
						}
					/>
				)}
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	workOrder: state.work_orders.detail,
	invoicesFetching: state.invoices.fetching,
	invoices: state.invoices,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	appendWorkOrderNotes: (entity) => dispatch(appendWorkOrderNotesForBuyer(entity)),
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForBuyer.readOne(id)),
	getInvoices: (params, targetCollectionName) =>
		dispatch(invoicesRestCrudThunksForBuyer.read(params, targetCollectionName)),
	getCount: (woId, status) =>
		dispatch(invoicesRestCrudThunksForBuyer.countBy({ workOrderId: woId, status: status }, status)),
	updateInvoice: (entity) => dispatch(invoicesRestCrudThunksForBuyer.update(entity)),
	updateGLCode: (entity) => dispatch(updateInvoiceGLCodeForBuyer(entity)),
	updatePONumber: (entity) => dispatch(updateInvoicePONumberForBuyer(entity)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(WorkOrderInvoicesDetailPage)
);
